import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Contact from "./components/Contact";
import Dashboard from "./components/Dashboard";
import EnglishMotets from "./components/EnglishMotets";
import Home from "./components/Home";
import Videos from "./components/Videos";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import VerifyEmail from "./components/VerifyEmail";
import ForgotPasswordContainer from "./components/ForgotPasswordContainer";
import ResetPassword from "./components/ResetPassword";
import Privacy from "./components/Privacy";
import MusicOverview from "./components/MusicOverview";
import Terms from "./components/Terms";

import { Provider } from "react-redux";
import { createStore } from "redux";
import reducers from "./reducers";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signedIn: false
    };
  }
  render() {
    return (
      <Provider store={createStore(reducers)}>
        <div className="App">
          <BrowserRouter>
            <div>
              <Nav signedIn={this.state.signedIn} />
              <Switch>
                <Route
                  path="/forgot-password"
                  component={ForgotPasswordContainer}
                />
                <Route path="/reset/:emailToken" component={ResetPassword} />
                <Route path="/verify-email/" component={VerifyEmail} />
                <Route exact path="/" component={EnglishMotets} />
                <Route path="/about" component={Home} />
                <Route path="/recordings" component={Videos} />
                <Route path="/contact" component={Contact} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/privacy" component={Privacy} />
                <Route path="/terms" component={Terms} />
                <Route path="/overview" component={MusicOverview} />
              </Switch>
              <Footer />
            </div>
          </BrowserRouter>
        </div>
      </Provider>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js